import { Link } from 'react-router-dom'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import {
  ContractsEmployeesJobCatalogLevelFragment,
  ContractsEmployeesJobCatalogRoleFragment,
  JobPositionLevelFragment,
  JobPositionRoleFragment,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  jobCatalogLevel?: ContractsEmployeesJobCatalogLevelFragment | null
  jobCatalogRole?: ContractsEmployeesJobCatalogRoleFragment | null
  jobCatalogTreeNodeLevel?: JobPositionLevelFragment
  jobCatalogTreeNodeRole?: JobPositionRoleFragment
}

const CurrentPosition = ({
  jobCatalogLevel,
  jobCatalogRole,
  jobCatalogTreeNodeLevel,
  jobCatalogTreeNodeRole,
}: Props) => {
  const { navigation } = useNavigation()
  const result: string[] = []

  const jobRole = jobCatalogTreeNodeRole?.name || jobCatalogRole?.name
  if (jobRole) result.push(jobRole)

  const jobLevel =
    jobCatalogTreeNodeLevel?.name || (jobCatalogLevel?.isDefault ? '' : jobCatalogLevel?.name)

  const positionLink = () => {
    if (!!jobCatalogTreeNodeLevel) {
      return `${navigation.employees.jobCatalog.overview.fullPath()}/${
        jobCatalogTreeNodeLevel.uuid
      }`
    } else {
      return navigation.employees.jobCatalog.fullPath()
    }
  }

  if (jobLevel) result.push(jobLevel)
  const position = result.join(', ')

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.job_position.current_position')}
      </Text>
      <Link to={positionLink()}>
        <Box gap="s8" flexDirection="row" alignItems="center">
          {position && (
            <Text size="400" weight="medium" color="grey1000">
              {position}
            </Text>
          )}
          {!position && (
            <Text size="400" weight="medium" color="grey600">
              {i18n.t('contract_versions.job_position.not_informed')}
            </Text>
          )}
          <Icon.Medium icon="arrow-right" color="grey800" />
        </Box>
      </Link>
    </Box>
  )
}
export default CurrentPosition
